import { defineComponent as o, computed as p, createBlock as s, openBlock as l, resolveDynamicComponent as m, unref as r, mergeProps as f, withCtx as i, createElementVNode as u, normalizeClass as c, renderSlot as d } from "vue";
import g from "../utils/isString.js";
const C = /* @__PURE__ */ o({
  __name: "AppTag",
  props: {
    href: {},
    target: { default: "_blank" },
    variant: { default: "primary" }
  },
  setup(t) {
    const n = t, a = p(() => g(n.href));
    return (e, h) => (l(), s(m(r(a) ? "a" : "span"), f({ "data-component-name": "AppTag" }, r(a) ? { href: e.href, target: e.target } : null), {
      default: i(() => [
        u("span", {
          class: c(e.variant)
        }, [
          d(e.$slots, "default", {}, void 0, !0)
        ], 2)
      ]),
      _: 3
    }, 16));
  }
});
export {
  C as default
};
//# sourceMappingURL=AppTag.vue2.js.map
